<template>
  <i-modal
    :title="toEdit.payment_number"
    :value="value"
    :load="loading"
    dontSave
    @input="$emit('input', $event)"
  >
    <v-row class="my-0">
      <!-- Código -->
      <v-col cols="12" sm="6" md="4" class="mb-2">
        <v-text-field
          disabled
          hide-details
          outlined
          :label="$t('code')"
          :value="toEdit.payment_number"
        />
      </v-col>

      <!-- Tipo de pago -->
      <v-col cols="12" sm="6" md="4" class="mb-2">
        <v-text-field
          disabled
          hide-details
          outlined
          :label="$t('paymenttype')"
          :value="toEdit.showType"
        />
      </v-col>

      <!-- Fecha -->
      <v-col cols="12" sm="6" md="4" class="mb-2">
        <v-text-field
          disabled
          hide-details
          outlined
          :label="$tc('date', 1)"
          :value="dateFormat(toEdit.date)"
        />
      </v-col>

      <!-- Cantidad -->
      <v-col cols="12" sm="6" md="4" class="mb-2">
        <v-text-field
          disabled
          hide-details
          outlined
          :label="$tc('amount', 1)"
          :value="toEdit.amount"
        />
      </v-col>

      <!-- Referencia -->
      <v-col cols="12" sm="6" md="8" class="mb-2">
        <v-text-field
          disabled
          hide-details
          outlined
          :label="$tc('reference', 1)"
          :value="toEdit.reference"
        />
      </v-col>

      <!-- Subórdenes asociadas al pago -->
      <v-col cols="12">
        <p class="font-weight-bold mb-0">
          {{
            toEdit.suborders.length > 1
              ? $tc('suborder', 0)
              : $tc('suborder', 1)
          }}:
        </p>
        <ul>
          <li v-for="(suborder, index) in toEdit.suborders" :key="index">
            {{ suborder }}
          </li>
        </ul>
      </v-col>
    </v-row>

    <!-- Pago anulado -->
    <div v-if="toEdit.canceled" class="mt-4">
      <p class="h3 text-danger font-weight-bold mb-2">
        {{ $tc('payment', 1) }} {{ $t('voided') }}
      </p>
      <v-textarea
        hide-details
        disabled
        outlined
        rows="3"
        :label="$t('reason')"
        :value="toEdit.reason"
      />
    </div>
  </i-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    toEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      dialog: false
    }
  },
  methods: {}
}
</script>
